import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_471 implements Validator {

    public static id = 'CTRL_471';
    private message = 'error.ctr_471';


    public LOG: LogService = new LogService(CTRL_471);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_471.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const firstNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const secondNameWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
                const thirdNameWithStepId = map.get(ctrl.value.rgCtrls.thirdChamp);
                const firstCtrl = form.controls[firstNameWithStepId];
                const secondCtrl = form.controls[secondNameWithStepId];
                const thirdCtrl = form.controls[thirdNameWithStepId];
                const valeur = !(firstCtrl.value == null || firstCtrl.value == 0);
                const fourchetteBasse = !(secondCtrl.value == null || secondCtrl.value == 0);
                const fourchetteHaute = !(thirdCtrl.value == null || thirdCtrl.value == 0);
                const fourchette = fourchetteBasse || fourchetteHaute;

                if (valeur && fourchette || !valeur && !fourchette) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}